<template>
  <b-container fluid class="header" v-if="help">
    <b-jumbotron fluid>
      <h2 class='text-white'>Analytics</h2>
      <p class='text-white'>Measure your success</p>
      <b-button @click='help = !help'>Get started</b-button>
    </b-jumbotron>

    <b-container class="mt-4">
      <b-card title="Analytics" class="mb-4">
        Analytics simplified to the core measurements to help you keep track of your progress.
      </b-card>
    </b-container>
  </b-container>
  
  <b-container fluid v-else>
    <div class="horizontal-menu">
      <b-row>
        <b-col>
          <h2>Analytics</h2>
        </b-col>
        <b-col class="float-right">
          <b-button class="float-right" variant="transparent" @click="help = !help"><i class="far fa-question-circle"></i></b-button>
        </b-col>
      </b-row>
      <b-nav>
        <b-nav-item :to="{name: 'site_analytics'}" exact exact-active-class="tab_active">Analytics</b-nav-item>
      </b-nav>
    </div>

    <router-view :profile="profile" :user="user" :site="site" />
  </b-container>
</template>

<script>

import { db } from '@/main.js'

export default {
  name: 'site_content',
  props: ['profile', 'user', 'site'],
  data() {
    return {
      help: this.site.help.analytics
    }
  },
  watch: {
    help(val) {
      if (this.site.help.analytics && !val) {
        db.collection('site').doc(this.site.id).update({'help.analytics': false})
      }
    }
  }
}
</script>

<style scoped>

</style>
